<template>
  <div ref="main" class="main" :style="{ width: `${boxSize}px`}">
    <div
      ref="boxImg"
      class="box-img"
      :style="{ height: `${boxSize}px`, width: `${boxSize}px`, backgroundImage: currentImg }"
      @mouseover="handleOver"
      @mousemove="handleMove"
      @mouseleave="handleLeave"
    >
      <!-- <img :src="currentImg" alt="img"> -->
      <div
        :style="{
          height: '100%',
          'background-image': `url(${currentImg})`,
          'background-repeat': 'no-repeat',
          'background-position': 'center',
          'background-size': 'contain'
        }"
      />
      <!-- <div v-show="isMouseOver" class="box-hover" :style="mousePositon" /> -->
    </div>
    <div
      v-show="isMouseOver"
      class="box-img-mini"
      :style="{ left: `${boxSize}px` }"
    >
      <img :src="currentImg" alt="img" :style="hoverBoxStyle">
    </div>
    <div class="spec-list">
      <a-button class="arrow-prev" @click="preLeft">
        <a-icon type="left" />
      </a-button>
      <a-button class="arrow-next" @click="nextRight">
        <a-icon type="right" />
      </a-button>
      <div class="spec-items">
        <ul class="lh" @mouseover="hoverImg">
          <li
            v-for="item in imglist"
            :key="item.id"
            :class="{ 'img-hover': item.id == currentId }"
            style="width:62px;height:62px;"
            :style="{
              'background-image': `url(${item.url})`,
              'background-repeat': 'no-repeat',
              'background-position': 'center',
              'background-size': 'contain'
            }"
          >
            <img :src="item.url" :data-img="item.id" style="width:60px;height:60px;opacity: 0">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PicZoom',
  props: {
    // 图片框大小
    boxSize: {
      type: Number,
      default: 430
    },
    // hover模糊框大小, 放大倍数根据此计算
    hoverBoxSize: {
      type: Number,
      default: 150
    }
  },
  data () {
    return {
      hoverLimitPosition: {
        maxTop: 0,
        minTop: 0,
        maxLeft: 0,
        minLeft: 0
      },
      isMouseOver: false,
      mousePositon: {
        width: this.hoverBoxSize + 'px',
        height: this.hoverBoxSize + 'px',
        top: '8px',
        left: '8px'
      },
      imglist: [],
      currentImg: '',
      currentId: 0
    }
  },
  computed: {
    // hover状态时阴影块的位置
    hoverBoxStyle () {
      return {
        top: `-${parseInt(this.mousePositon.top) - 8}px`,
        left: `-${parseInt(this.mousePositon.left) - 8}px`,
        zoom: this.boxSize / this.hoverBoxSize,
        width: `${this.boxSize}px`,
        height: `${this.boxSize}px`
      }
    }
  },
  mounted () {
    this.hoverLimitPosition = {
      maxTop: this.$refs.main.offsetTop + this.boxSize,
      minTop: this.$refs.main.offsetTop,
      maxLeft: this.$refs.main.offsetLeft + this.boxSize,
      minLeft: this.$refs.main.offsetLeft
    }
  },
  methods: {
    setPicList (list) {
      if (!list || !list.length) {
        return
      }
      this.imglist = list
      this.currentImg = this.imglist[0].url
      this.currentId = this.imglist[0].id
    },
    handleOver () {
      // this.isMouseOver = true
    },
    handleMove (e) {
      // if (e.clientY < this.hoverLimitPosition.minTop + this.hoverBoxSize / 2) {
      //   this.mousePositon.top = this.hoverLimitPosition.minTop + 'px'
      // } else if (
      //   e.clientY >
      //   this.hoverLimitPosition.maxTop - this.hoverBoxSize / 2
      // ) {
      //   this.mousePositon.top =
      //     this.hoverLimitPosition.maxTop - this.hoverBoxSize + 'px'
      // } else {
      //   this.mousePositon.top = e.clientY - this.hoverBoxSize / 2 + 'px'
      // }
      // if (e.clientX < this.hoverLimitPosition.minLeft + this.hoverBoxSize / 2) {
      //   this.mousePositon.left = this.hoverLimitPosition.minLeft + 'px'
      // } else if (
      //   e.clientX >
      //   this.hoverLimitPosition.maxLeft - this.hoverBoxSize / 2
      // ) {
      //   this.mousePositon.left =
      //     this.hoverLimitPosition.maxLeft - this.hoverBoxSize + 'px'
      // } else {
      //   this.mousePositon.left = e.clientX - this.hoverBoxSize / 2 + 'px'
      // }
    },
    handleLeave () {
      // this.isMouseOver = false
    },
    hoverImg (e) {
      const id = e.target.dataset.img
      if (id) {
        this.currentId = Number(id)
        this.currentImg = e.target.src
      }
    },
    // 找到下一个数据 并位移 图片不够不位移
    nextRight () {
      for (let index = 0; index < this.imglist.length; index++) {
        const item = this.imglist[index]
        console.log(item.id, this.currentId, index, this.imglist.length - 1)

        if (item.id === this.currentId && index < this.imglist.length - 1) {
          this.currentImg = this.imglist[index + 1].url
          this.currentId = this.imglist[index + 1].id
          break
        }
      }
      // this.imglist.forEach((item, index) => {
      //   if (item.id === this.currentId && index < this.imglist.length - 1) {
      //     console.log(item, item)
      //     this.currentImg = this.imglist[index + 1].url
      //     this.currentId = this.imglist[index + 1].id
      //   }
      // })
    },
    preLeft () {
      this.imglist.forEach((item, index) => {
        if (item.id === this.currentId && index >= 1) {
          this.currentImg = this.imglist[index - 1].url
          this.currentId = this.imglist[index - 1].id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.lh {
  zoom: 1;
  padding: 0;
}
.lh li {
  float: left;
  *display: inline;
  list-style: none;
}

.spec-list {
  margin-top: 15px;
  position: relative;
  _zoom: 1;
  min-height: 62px;
  &::after {
    content: ' ';
    clear: both;
  }
}

.arrow-next {
  display: block;
  width: 30px;
  padding:0px;
  height: 62px;
  float: left;
  position: absolute;
  line-height: 52px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #E9E9E9;
  border-radius: 0px 6px 6px 0px;
  color: #B7B7B7;
}
.arrow-next:hover,.arrow-prev:hover {
    color: #FFFFFF;
  background: #59C3E1;

}
.arrow-prev {
  display: block;
  width: 30px;
  padding:0px;
  height: 62px;
  float: left;
  position: absolute;
  line-height: 52px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #E9E9E9;
  border-radius: 6px 0px 0px 6px;
  color: #B7B7B7;
}

.spec-list .arrow-next i,
.spec-list .arrow-prev i {
  display: block;
}
.spec-list .arrow-prev {
  left: 0;
}

.spec-list .arrow-next {
  right: 0;
}
.spec-items {
  /* width: 350px; */
  width: 290px;
  margin: 0 auto;
  overflow: hidden;
}
.spec-items ul {
  width: 2000px;
}
.spec-items ul li {
  float: left;
  margin: 0 5px;
  max-width: 60px;
  max-height: 70px;
}
.ctCloth .spec-items ul li .thumb_video {
  padding: 6px 0;
}
.spec-items ul li img {
  border: 2px solid #fff;
  *padding-bottom: 1px;
}
.spec-items ul li img.thumb_video {
  width: 54px;
  height: 62px;
  background: url(//static.360buyimg.com/item/unite/1.0.131/components/default-soa/preview/i/thumb-video-1.png)
    center center no-repeat;
  border: 2px solid #fff;
}
.clothing .spec-items ul li img.thumb_video {
  width: 50px;
  height: auto;
}
/* .spec-items ul li.img-hover img,
.spec-items ul li:hover img {
  border: 2px solid #59C3E1;
} */
.spec-items ul li ,
.spec-items ul li {
  border: 2px solid #FFF;
}
.spec-items ul li.img-hover ,
.spec-items ul li:hover {
  border: 2px solid #59C3E1;
}
#spec-img {
  min-height: 300px;
}
.preview-info .left-btns {
  float: left;
}
.preview-info .left-btns a {
  cursor: pointer;
  margin-right: 2px;
}
.preview-layer .layer-side .side-list .list-page .next.disabled,
.preview-layer .layer-side .side-list .list-page .prev.disabled {
  cursor: default;
}
.preview-info .left-btns a i {
  display: inline-block;
  *display: inline;
  *zoom: 1;
  vertical-align: middle;
  margin-right: 5px;
}
.preview-info .left-btns a:hover {
  color: #59C3E1;
}
.preview-info .left-btns .follow i {
  width: 14px;
  height: 13px;
  background-image: url(//static.360buyimg.com/item/unite/1.0.131/components/default-soa/preview/i/__sprite.png);
  background-position: -44px -40px;
}
.preview-info .left-btns .share i {
  width: 15px;
  height: 14px;
  background-image: url(//static.360buyimg.com/item/unite/1.0.131/components/default-soa/preview/i/__sprite.png);
  background-position: -45px -24px;
}
.preview-info .left-btns .compare i {
  width: 15px;
  height: 16px;
  background-image: url(//static.360buyimg.com/item/unite/1.0.131/components/default-soa/preview/i/__sprite.png);
  background-position: -30px -24px;
}
.preview-info .right-btns {
  float: right;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.main {
  // width:430px;
  display: inline-block;
  position: relative;
  .box-img {
    // width: 430px;
    // height: 430px;
    // line-height: 430px;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    z-index: 9;
    img {
      display: inline-block;
      max-height: 100%;
      width: 100%;
    }
  }
  .box-hover {
    background: rgba(236, 221, 152, 0.3);
    position: fixed;
    top: 0;
    bottom: 0;
  }
  .box-img-mini {
    margin-left: 10px;
    border: 1px solid #f2f2f2;
    position: absolute;
    bottom: 0;
    top: 0;
    width: 100%;
    overflow: hidden;
    img {
      position: absolute;
    }
  }
}
</style>
